import { render, staticRenderFns } from "./customer_link.vue?vue&type=template&id=684a9a94&scoped=true&"
import script from "./customer_link.vue?vue&type=script&lang=js&"
export * from "./customer_link.vue?vue&type=script&lang=js&"
import style0 from "./customer_link.vue?vue&type=style&index=0&id=684a9a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a9a94",
  null
  
)

export default component.exports